module.exports = __webpack_public_path__ + "img/logo.f85082b3.png";